import { Box, styled } from "@mui/material";

export const CellWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
